// @flow

export const LANGUAGE_CODE: string = process.env.REACT_APP_LANGUAGE_CODE
  ? process.env.REACT_APP_LANGUAGE_CODE.toLowerCase()
  : 'en';
export const COUNTRY_CODE: string = process.env.REACT_APP_COUNTRY_CODE
  ? process.env.REACT_APP_COUNTRY_CODE
  : 'DK';

export type LocaleType =
  | 'da_DK'
  | 'nb_NO'
  | 'sv_SE'
  | 'sv_FI'
  | 'fi_FI'
  | 'en_DK'
  | 'en_GB'
  | 'en_FI'
  | 'en_SE'
  | 'en_NO';

//unsafe cast to LocaleType
export const DEFAULT_LOCALE: LocaleType =
  (`${LANGUAGE_CODE}_${COUNTRY_CODE}`: any);
